import { render, staticRenderFns } from "./WorkBreakList.vue?vue&type=template&id=274bfe98&"
import script from "./WorkBreakList.vue?vue&type=script&lang=js&"
export * from "./WorkBreakList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports